import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@redux/store';
import {
  resetDetails,
  setMessageIsExpanded,
  setSelectedLogId,
} from '../../../redux/Ingestion.slice';
import { fetchIngestionLogDetails } from '../../../redux/Ingestion.api';

export const useFetchLogDetails = () => {
  const dispatch = useAppDispatch();

  const selectedLogId = useAppSelector((state) => state.ingestion.selectedLogId);

  const fetchDetails = useCallback(
    (id: string | null) => {
      if (id !== null) {
        dispatch(fetchIngestionLogDetails(id));
      } else {
        dispatch(resetDetails());
      }
    },
    [dispatch]
  );

  const fetchLogDetails = useCallback(
    (id: string | null) => {
      // close/reset expanded message
      dispatch(setMessageIsExpanded(false));

      if (selectedLogId === id) {
        dispatch(setSelectedLogId(null));
      } else {
        dispatch(setSelectedLogId(id));
        fetchDetails(id);
      }
    },
    [selectedLogId, fetchDetails, dispatch]
  );

  return {
    fetchDetails,
    fetchLogDetails,
  };
};
